import { render, staticRenderFns } from "./PolizasAdministracionCard.vue?vue&type=template&id=cb89a962&scoped=true&"
import script from "./PolizasAdministracionCard.vue?vue&type=script&lang=js&"
export * from "./PolizasAdministracionCard.vue?vue&type=script&lang=js&"
import style0 from "./PolizasAdministracionCard.vue?vue&type=style&index=0&id=cb89a962&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb89a962",
  null
  
)

export default component.exports